// Presentation only: API stage/origin codes and all metric values stay unchanged.
const entries = {
  'application funnel': ['funil de candidaturas', 'embudo de candidaturas', 'application funnel'],
  'aggregated vacancy views, applications and candidate stages': ['visualizações de vagas, candidaturas e etapas dos candidatos em conjunto', 'vistas de ofertas, candidaturas y etapas de los candidatos en conjunto', 'aggregated vacancy views, applications and candidate stages'],
  'from': ['de', 'desde', 'from'],
  'to': ['até', 'hasta', 'to'],
  'loading': ['carregando', 'cargando', 'loading'],
  'update': ['atualizar', 'actualizar', 'update'],
  'dashboard could not be loaded': ['não foi possível carregar o funil. Tente atualizar novamente.', 'no se pudo cargar el embudo. Vuelve a actualizarlo.', 'the funnel could not be loaded. Try updating again.'],
  'no data': ['sem dados', 'sin datos', 'no data'],
  'no metrics available for this period': ['nenhuma métrica disponível para este período', 'no hay métricas disponibles para este período', 'no metrics available for this period'],
  'unique views': ['visualizações únicas', 'vistas únicas', 'unique views'],
  'views': ['visualizações', 'vistas', 'views'],
  'applications': ['candidaturas', 'candidaturas', 'applications'],
  'validating': ['em análise', 'en revisión', 'under review'],
  'accepted': ['aceitos', 'aceptados', 'accepted'],
  'refused': ['rejeitados', 'rechazados', 'rejected'],
  'application rate': ['taxa de candidatura', 'tasa de candidaturas', 'application rate'],
  'funnel by stage': ['funil por etapa', 'embudo por etapa', 'funnel by stage'],
  'recruitment efficiency': ['eficiência do recrutamento', 'eficiencia de la selección', 'recruitment efficiency'],
  'aggregated metrics without candidate identification': ['métricas agregadas sem identificação dos candidatos', 'métricas agregadas sin identificar a los candidatos', 'aggregated metrics without candidate identification'],
  'average time to validating': ['tempo médio até a análise', 'tiempo medio hasta la revisión', 'average time to review'],
  'average time to accepted': ['tempo médio até a aceitação', 'tiempo medio hasta la aceptación', 'average time to acceptance'],
  'average time to refused': ['tempo médio até a rejeição', 'tiempo medio hasta el rechazo', 'average time to rejection'],
  'conversion': ['conversão', 'conversión', 'conversion'],
  'origin': ['origem', 'origen', 'origin'],
  'acceptance rate': ['taxa de aceitação', 'tasa de aceptación', 'acceptance rate'],
  'direct': ['direta', 'directa', 'direct'],
  'invitation': ['convite', 'invitación', 'invitation'],
  'daily evolution': ['evolução diária', 'evolución diaria', 'daily evolution'],
  'date': ['data', 'fecha', 'date'],
};

export default Object.fromEntries(['pt', 'es', 'en'].map((locale, index) => [
  locale, Object.fromEntries(Object.entries(entries).map(([key, values]) => [`funnel ${key}`, values[index]])),
]));
